export const sleep = (timeMs: number) =>
  new Promise((resolve) => setTimeout(resolve, timeMs))

// Lock that gates opening the Zendesk widget until the messenger
// authentication (loginUser) has completed successfully.
let isZendeskAuthenticated = false

export const setZendeskAuthenticated = (value: boolean): void => {
  isZendeskAuthenticated = value
}

export const openZendeskChat = (zE: any): void => {
  if (!isZendeskAuthenticated) {
    console.warn('Zendesk chat is not available until authentication completes')
    return
  }
  zE('messenger', 'show')
  zE('messenger', 'open')
  zE('messenger:on', 'close', function () {
    zE('messenger', 'hide')
  })
}
